import supervisorTpl from './views/supervisorView.html';
import './profileSetting.scss';
import supervisorViewCtrl from './controllers/supervisorViewController';


const name = 'supervisorView';
var module = angular.module("app.supervisorView", [

]).component(name, {
    template: supervisorTpl,
    controllerAs: name,
    controller: supervisorViewCtrl
}).controller('supervisorViewCtrl', supervisorViewCtrl);


// WEBPACK FOOTER //
// ./src/app/profileSetting/supervisorViewModule.js